<span>
    {{partnerName}}
</span>
